import api from "./apiConfig";
import * as link from "./link/";
import * as shortlink from "./shortlink/";
import * as linkUpload from "./linkUpload/";
import * as links from "./links/";
import * as targetCheck from "./targetCheck/";
import * as admin from "./admin/";
import * as settings from "./settings/";
import * as content from "./content/";
import * as user from "./user/";

const baseURL =
  process.env.REACT_APP_STAGING === "1"
    ? "/api"
    : "http://libi-stage.corp.feld-m.de:89/api";

const API = {
  LINKS: {
    getArchive: links.getArchive(api, baseURL + "/archive"),
    getFilters: links.getFilters(api, baseURL + "/archive"),
    EXPORT: {
      csv: links.export(api, baseURL + "/archive/export/csv"),
      excel: links.export(api, baseURL + "/archive/export/excel"),
    },
    archiveLink: links.archiveLink(api, baseURL + "/archive/hidelink/$"),
    restoreLink: links.archiveLink(api, baseURL + "/archive/unhidelink/$"),
  },
  LINK: {
    duplicate: link.duplicate(api, baseURL + "/link/duplicate/$"),
    validate: link.validate(api, baseURL + "/link/validate"),
    create: link.create(api, baseURL + "/link/create"),
    addItem: link.addItem(api, baseURL + "/link/additem/$"),
    getQR: link.getQR(api, baseURL + "/link/qrcode?url=$"),
    TARGET_CHECK: {
      url: link.checkUrl(api, baseURL + "/monitoring/runcheckforurl"),
      id: link.checkId(api, baseURL + "/monitoring/runcheckforlink/$"),
      getSettings: link.checkGetSettings(
        api,
        baseURL + "/monitoring/settings/$"
      ),
      updateSettings: link.checkUpdateSettings(
        api,
        baseURL + "/monitoring/settings/$"
      ),
    },
  },
  SHORTLINK: {
    validate: shortlink.validate(api, baseURL + "/link/short/$/validate"),
    create: shortlink.create(api, baseURL + "/link/short/$/create"),
  },
  LINK_UPLOAD: {
    uploadTemplate: linkUpload.uploadTemplate(
      api,
      baseURL + "/bulk/upload?emailcc=$"
    ),
    downloadTemplate: linkUpload.downloadTemplate(
      api,
      baseURL + "/bulk/downloadtemplate/$/$"
    ),
    getTemplates: linkUpload.getTemplates(api, baseURL + "/bulk/templates/$"),
    getBulkUploads: linkUpload.getBulkUploads(api, baseURL + "/bulk/list"),
    getBulkUpload: linkUpload.getBulkUpload(api, baseURL + "/bulk/$"),
    getParameterItems: linkUpload.getParameterItems(
      api,
      baseURL + "/bulk/getParameterItems/$/$"
    ),
    createBulkUpload: linkUpload.createBulkUpload(
      api,
      baseURL + "/bulk/uploaddata"
    ),
    downloadBulkExcel: linkUpload.downloadBulkExcel(
      api,
      baseURL + "/bulk/step/$/excel"
    ),
  },
  TARGET_CHECK: {
    getDashboard: targetCheck.getDashboard(
      api,
      baseURL + "/monitoring/dashboard"
    ),
  },
  ADMIN: {
    HISTORY: {
      get: admin.history.get(api, baseURL + "/history"),
    },
    PARAMETERS: {
      get: admin.parameters.get(api, baseURL + "/parameter"),
      getAll: admin.parameters.get(api, baseURL + "/parameter/extended"),
      getSingle: admin.parameters.get(api, baseURL + "/parameter/$/extended"),
      update: admin.parameters.update(api, baseURL + "/parameter/$"),
      add: admin.parameters.add(api, baseURL + "/parameter"),
    },
    ITEMS: {
      get: admin.items.get(api, baseURL + "/item"),
      getAll: admin.items.get(api, baseURL + "/item/extended"),
      getSingle: admin.items.get(api, baseURL + "/item/$/extended"),
      update: admin.items.update(api, baseURL + "/item/$"),
      remove: admin.items.remove(api, baseURL + "/item/$"),
      add: admin.items.add(api, baseURL + "/item"),
      checkSimilar: admin.items.checkSimilar(
        api,
        baseURL + "/item/similaritems"
      ),
    },
    ITEM_GROUPS: {
      getAll: admin.itemGroups.get(api, baseURL + "/itemgroup/extended"),
      getSingle: admin.itemGroups.get(api, baseURL + "/itemgroup/$/extended"),
      update: admin.itemGroups.update(api, baseURL + "/itemgroup/$"),
    },
    TAG_GROUPS: {
      get: admin.tagGroups.get(api, baseURL + "/taggroup"),
      getAll: admin.tagGroups.get(api, baseURL + "/taggroup/extended"),
      getSingle: admin.tagGroups.get(api, baseURL + "/taggroup/$/extended"),
      update: admin.tagGroups.update(api, baseURL + "/taggroup/$"),
      add: admin.tagGroups.add(api, baseURL + "/taggroup"),
    },
    USERS: {
      EXPORT: {
        excel: admin.users.export(api, baseURL + "/user/export/excel"),
      },
      get: admin.users.get(api, baseURL + "/user"),
      getAll: admin.users.get(api, baseURL + "/user/extended"),
      getSingle: admin.users.get(api, baseURL + "/user/$/extended"),
      update: admin.users.update(api, baseURL + "/user/$"),
      resetExpiration: admin.users.resetExpiration(
        api,
        baseURL + "/user/$/resetexpiration"
      ),
      add: admin.users.add(api, baseURL + "/user"),
    },
    PROFILES: {
      get: admin.profiles.get(api, baseURL + "/profile"),
      getAll: admin.profiles.get(api, baseURL + "/profile/extended"),
      update: admin.profiles.update(api, baseURL + "/profile/$"),
      add: admin.profiles.add(api, baseURL + "/profile"),
    },
  },
  SETTINGS: {
    get: settings.get(api, baseURL + "/settings"),
  },
  USER: {
    login: user.login(api, baseURL + "/token"),
    profile: user.profile(api, baseURL + "/profile/userprofiles"),
    refreshToken: user.refreshToken(api, baseURL + "/token"),
    PASSWORD_CHANGE: {
      request: user.passwordRequest(api, baseURL + "/account/RestorePassword"),
      reset: user.passwordReset(api, baseURL + "/account/ResetPassword"),
    },
  },
  CONTENT: {
    dataProtection: content.dataProtection(
      api,
      baseURL + "/content/customdataprotectionde"
    ),
    dataProtectionEn: content.dataProtection(
      api,
      baseURL + "/content/customdataprotection"
    ),
    imprint: content.imprint(api, baseURL + "/content/customimprint"),
    additional: content.imprint(
      api,
      baseURL + "/content/additionaltutorialinformation"
    ),
  },
};

export default API;



// WEBPACK FOOTER //
// ./src/services/api/index.ts